// import Main from '@/view/main'

export default {
  path: 'message',
  meta: {
    title: '消息管理'
  },
  component: () => import('@/components/parent-view'),
  name: 'message',
  children: [
    {
      path: 'feedback',
      meta: {
        title: '意见反馈'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          meta: {
            title: '意见反馈',
            ignoreBreadCrumb: true
          },
          name: 'om-message-feedback',
          component: () => import('@/view/message/index.vue')
        },
        {
          path: 'detail',
          meta: {
            title: '反馈详情'
          },
          name: 'om-message-feedback-detail',
          component: () => import('@/view/message/detail')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/message.js